/**
 * 9 周年庆活动 — 应用启动即预加载切图
 * 由 main.ts 在创建应用时调用：进入官网（任意页面）就开始后台拉取全部切图，
 * 用户点击蛋糕/自动弹窗时素材基本已就绪，弹窗秒开。
 * 预加载进度为模块级共享单例（见 composables/useImagePreload），
 * 入口组件与弹窗复用同一份状态，不会重复发起请求
 */
import { ANNIVERSARY_IMAGES } from './constants'
import { startSharedPreload } from './composables/useImagePreload'

export function preloadAnniversaryImages() {
  startSharedPreload(ANNIVERSARY_IMAGES)
}
